import Swiper from 'swiper/js/swiper';
import { gsap } from 'gsap/dist/gsap';
// eslint-disable-next-line no-unused-vars
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default {
  init() {

  /**************************************************************
  -> Pageload animation
  **************************************************************/
  function pageContactLoadAnimation() {
    const tl = gsap.timeline({ delay: 0.5, duration: 0.75 })

    tl.to('.hero-contact .wrap-fullscreen-image', { opacity: 1 })
    .to('.hero-contact .dark-overlay-hero', { opacity: 1 }, '>-0.15')
    .to('.hero-contact .wrap-hero-header h1', { opacity: 1 }, '>-0.25')
    .to('.hero-contact .wrap-hero-header .wrap-hero-links', { opacity: 1 }, '>-0.25')
  }
  pageContactLoadAnimation()

    /**************************************************************
    -> Contact intro anim on scroll
    **************************************************************/
    function inViewAnimContactIntro() {
      gsap.fromTo('.intro-contact .intro-container h2' , 
      { opacity: 0 },
      {
        opacity: 1,
        delay: 0.25,
        duration: 0.5,
        scrollTrigger: '.intro-contact',
      })

      gsap.fromTo('.intro-contact .intro-container p' , 
      { opacity: 0 },
      {
        opacity: 1,
        delay: 0.35,
        duration: 0.5,
        scrollTrigger: '.intro-contact .wrap-text-and-landscape',
      })
    }
    inViewAnimContactIntro();

    /**************************************************************
    -> Contact Form and contact anim on scroll
    **************************************************************/
    function inViewAnimContactForm() {
      gsap.fromTo('.contacts-and-form .wrap-contacts-and-form .contact-points' , 
      { opacity: 0 },
      {
        opacity: 1,
        delay: 0.25,
        duration: 0.5,
        scrollTrigger: '.contacts-and-form',
      })

      gsap.fromTo('.contacts-and-form .wrap-contacts-and-form .main-address' , 
      { opacity: 0 },
      {
        opacity: 1,
        delay: 0.25,
        duration: 0.5,
        scrollTrigger: '.contacts-and-form',
      })

      gsap.fromTo('.contacts-and-form .wrap-contacts-and-form .wrap-form' , 
      { opacity: 0 },
      {
        opacity: 1,
        delay: 0.35,
        duration: 0.5,
        scrollTrigger: '.contacts-and-form',
      })
    }
    inViewAnimContactForm();

    /**************************************************************
    -> Contact Quotes anim on scroll
    **************************************************************/
    function inViewAnimQuote() {
      gsap.fromTo('.clients-say-contact h2' , 
      { opacity: 0 },
      {
        opacity: 1,
        delay: 0.25,
        duration: 0.5,
        scrollTrigger: '.clients-say-contact',
      })

      gsap.fromTo('.clients-say-contact .wrap-carousel' , 
      { opacity: 0 },
      {
        opacity: 1,
        delay: 0.25,
        duration: 0.5,
        scrollTrigger: '.clients-say-contact h2',
      })
    }
    inViewAnimQuote();


    // eslint-disable-next-line no-unused-vars
    let contactQuoteSwiper = new Swiper ('.swiper-container-contact-clients-say', {
      loop: true,
      slidesPerView: 1,
      roundLengths: true,
      grabCursor: true,
      speed: 500,
      navigation: {
        nextEl: '.swiper-clients-say-button-next',
        prevEl: '.swiper-clients-say-button-prev',
      },
    })
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/contact.js